/* ZSportsTech — section-nsenq.js
   Scoped to #sc-nsenq-form (Net Sessions enquiry). Vanilla JS only, namespaced.
   Posts to the Apps Script `enquiry` action → stores an `enquiry` metaobject
   and emails the owner via Resend.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var form = document.getElementById('sc-nsenq-form');
  if (!form) return;

  var S = window.SCNS;

  /* ── 1. Enquiry-type chips: single-select, mirror into hidden input ── */
  var chips = form.querySelectorAll('.sc-nsenq__chip');
  var typeField = document.getElementById('sc-nsenq-type');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      if (typeField) typeField.value = chip.textContent.trim();
    });
  });

  /* ── 2. Submit → backend ─────────────────────────────────────────────
     The note under the button is reused as the status line so no new UI is
     introduced; it is restored if the customer edits and resubmits.        */
  var btn  = form.querySelector('.sc-nsenq__submit');
  var note = form.querySelector('.sc-nsenq__note');
  var noteDefault = note ? note.textContent : '';
  var busy = false;

  function setNote(text) { if (note) note.textContent = text; }
  function setLabel(text) { if (btn && btn.firstChild) btn.firstChild.textContent = text + ' '; }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;

    var name    = (form.querySelector('[name="contact[name]"]')  || {}).value || '';
    var phone   = (form.querySelector('[name="contact[phone]"]') || {}).value || '';
    var message = (form.querySelector('[name="contact[body]"]')  || {}).value || '';
    var type    = typeField ? typeField.value : '';

    if (!name.trim())    { setNote('Please enter your name.'); return; }
    if (!phone.trim())   { setNote('Please enter your phone number.'); return; }
    if (S && !S.isPhone(phone)) { setNote(S.message('bad_phone')); return; }
    if (!message.trim()) { setNote('Please tell us what you need.'); return; }

    if (!S || !S.enabled) {
      setNote('Enquiries are not set up yet; please WhatsApp us instead.');
      return;
    }

    busy = true;
    setLabel('Sending…');
    setNote(noteDefault);

    S.call({
      action: 'enquiry',
      name: name.trim(),
      phone: S.normPhone(phone),
      message: message.trim(),
      enquiry_type: type
    }).then(function () {
      succeed();
    }).catch(function (err) {
      /* `email_failed` means the enquiry WAS stored and only the owner's
         notification bounced. Telling the customer it failed would be a lie —
         and they would send it again. Treat it as success; the team can see it
         in the Shopify admin. Same for a missing Resend config. */
      if (err.message === 'email_failed' || err.message === 'resend_not_configured') {
        succeed();
        return;
      }
      busy = false;
      setLabel('Send enquiry');
      setNote(S.errText(err));
    });
  });

  function succeed() {
    busy = true;                       // stays locked; the enquiry is in
    setLabel('Enquiry sent');
    if (btn) btn.disabled = true;
    setNote('Thanks, we have your enquiry. Reply within 1–2 days.');
    form.querySelectorAll('.sc-nsenq__input, .sc-nsenq__textarea').forEach(function (i) { i.value = ''; });
  }
}());
